/**
 * /sysadmin/catalog/models — redirects to /sysadmin/models.
 *
 * Per `catalog.tsx` SUB_TABS spec the Models sub-tab deep-links to the
 * legacy `/sysadmin/models` route (see the `external` property on the
 * tab definition). The TanStack route tree, however, didn't have any
 * file at `/sysadmin/catalog/models`, so direct navigation to that
 * URL (reload, browser-stored bookmark, deep-link from the spec test
 * corpus) rendered the framework "Not Found" fallback in the content
 * area while the tab strip still rendered correctly — see #881.
 *
 * The same gap broke #883 (Functions and Models API rows missing from
 * the DOM): SYS-CATALOG-005 exercises the canonical Catalog landing
 * which is documented in `catalog.index.tsx` as redirecting here. With
 * no Models route, the landing flow ended at "Not Found" and never
 * mounted the list component.
 *
 * Sibling tabs (Functions, MCP, Tools, Workflows, Agents, Skills,
 * Prompts) all have their own first-class catalog routes; Models is the
 * outlier because the existing `/sysadmin/models` tree is the canonical
 * authoring surface and physically relocating it under `catalog/` is
 * deferred until the Catalog IA settles (see `catalog.tsx` header).
 * Until then this thin redirect keeps the URL space honest.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/catalog/models')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/models', replace: true });
  },
});
